import { useRef, useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Pause, Play } from "lucide-react";
import { mediaUrl } from "../../data/site";
import { Reveal } from "./Reveal";

const isAudio = (u = "") => u.startsWith("/api/files/") || /\.(mp3|wav|m4a|aac|ogg|flac)(\?|$)/i.test(u);

const Row = ({ s, i, playingId, onToggle }) => {
  const audio = isAudio(s.url);
  const on = playingId === s.id;
  return (
    <motion.div whileHover={{ x: 8 }} data-testid={`song-row-${s.id}`}
      className={`flex items-center gap-4 border-b border-[var(--line)] py-4 sm:gap-6 ${on ? "text-[var(--cash)]" : ""}`}>
      <span className="w-8 font-mono text-xs text-zinc-400">{String(i + 1).padStart(2, "0")}</span>
      <div className="h-14 w-14 shrink-0 overflow-hidden rounded-xl bg-[var(--ink-3)]">
        <img src={s.cover ? mediaUrl(s.cover) : "/mae-logo-ink.webp"} alt="" className="h-full w-full object-cover" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="truncate font-display text-2xl uppercase">{s.title || "Untitled"}</p>
        <p className="truncate font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">{s.artist || "Money Alwayz"}</p>
      </div>
      {audio ? (
        <button data-testid={`song-play-${s.id}`} onClick={() => onToggle(s)} aria-label="Play"
          className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[var(--cash)] text-[var(--ink)] transition-transform hover:scale-110">
          {on ? <Pause size={18} fill="currentColor" /> : <Play size={18} fill="currentColor" />}
        </button>
      ) : (
        <a data-testid={`song-link-${s.id}`} href={s.url} target="_blank" rel="noopener noreferrer"
          className="flex shrink-0 items-center gap-2 rounded-full border border-[var(--line)] px-4 py-3 font-mono text-xs uppercase tracking-[0.2em] hover:border-[var(--cash)]">
          Listen <ArrowUpRight size={14} />
        </a>
      )}
    </motion.div>
  );
};

export const Songs = ({ songs = [] }) => {
  const audioRef = useRef(null);
  const [playingId, setPlayingId] = useState(null);
  if (!songs.length) return null;
  const toggle = (s) => {
    const a = audioRef.current;
    if (playingId === s.id) { a.pause(); setPlayingId(null); return; }
    a.src = mediaUrl(s.url);
    a.play().catch(() => {});
    setPlayingId(s.id);
  };
  return (
    <section id="songs" data-testid="songs-section" className="px-4 pb-24 sm:px-8 lg:px-16">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-zinc-400">Tracklist</p>
          <div className="mt-6 border-t border-[var(--line)]">
            {songs.map((s, i) => <Row key={s.id} s={s} i={i} playingId={playingId} onToggle={toggle} />)}
          </div>
        </Reveal>
        <audio ref={audioRef} onEnded={() => setPlayingId(null)} className="hidden" />
      </div>
    </section>
  );
};
